import { IconButton } from '@mint/ui';
import styled from 'styled-components';

export const ViewportSizeIconButton = styled(IconButton)`
  &${IconButton} {
    border-radius: 1.5rem;
    font-size: 1.5rem;
    height: 3rem;
    width: 3rem;
  }
`;

ViewportSizeIconButton.displayName = 'ViewportSizeIconButton';
